import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

export default function Notifications() {
  const [list, setList] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/notifications");
      setList(data);
      api.post("/notifications/mark-read").catch(() => {});
    })();
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10">
      <div className="overline">Inbox</div>
      <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-white mt-2 mb-8">
        Notifications
      </h1>

      {list.length === 0 ? (
        <div className="bp-surface rounded-2xl p-12 text-center text-gray-500">
          <Bell className="w-8 h-8 mx-auto mb-3 opacity-40" />
          You're all caught up.
        </div>
      ) : (
        <div className="space-y-2">
          {list.map((n) => (
            <div key={n.id} className="bp-surface rounded-xl p-4 flex gap-3" data-testid={`notification-${n.id}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${
                n.read ? "bg-white/5" : "bg-[#D4AF37]/10 border border-[#D4AF37]/30"
              }`}>
                <Bell className="w-4 h-4 text-[#D4AF37]" />
              </div>
              <div className="flex-1">
                <div className="flex items-baseline justify-between gap-2">
                  <div className="text-white text-sm font-medium">{n.title}</div>
                  <div className="text-[11px] text-gray-500 shrink-0">
                    {new Date(n.created_at).toLocaleString()}
                  </div>
                </div>
                <div className="text-sm text-gray-400 mt-1">{n.message}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
